import React from 'react';

const Documents = () => (
  <div style={{ padding:'1rem' }}>
    <h1 style={{ marginTop:0 }}>Documents</h1>
    <p>Upload and manage compliance / business documents. Verification workflow coming soon.</p>
  </div>
);

export default Documents;
